<template>
    <div>
        <div class="container mt-4">
            <div class="row">
                <div class="col-8 offset-2">
                    <div class="card shadow-sm">
                        <div class="card-body">
                            <h5 class="card-title">
                                {{ $t('taxi.pages.payment_error.header') }}
                            </h5>

                            {{ $t('taxi.pages.payment_error.details') }}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>


<script>
    export default {

    };
</script>
